import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Join from "./Pages/Join";
import Chat from "./Pages/Chat";
import Video from './Pages/Video';
import VideoPage from './Pages/VideoPage'


function App() {
  return (
    <Router>
      <div className="App">
      <Routes>
  <Route path="/" element={<Join />} />
  <Route path="/chat" element={<Chat />} />
  <Route path="/video" element={<Video />} />
  <Route path="/videoPage" element={<VideoPage />} /> {/* Must match navigate("/videoPage") */}
</Routes>
      </div>
    </Router>
  );
}

export default App;
